export class Offset {
  pageSize: number;
  pageIndex: number;
  orderField: string = null;
  orderDirection: string = null;

  constructor(pageSize?: number, pageIndex?: number) {
    if (!pageSize) {
      this.pageSize = 10;
    } else {
      this.pageSize = pageSize;
    }

    if (!pageIndex) {
      this.pageIndex = 0;
    } else {
      this.pageIndex = pageIndex;
    }

  }
}
